import Education from './components/education/Education';
import Landing from './components/landing/Landing';
import Projects from './components/projects/Projects';
import Experience from './components/experience/Experience';
import Contact from './components/contact/Contact'
import Nav from './components/nav/Nav';
import Footer from './components/Footer/Footer';
import background from './images/wavey-fingerprint.svg'

function App() {
  return (
    <div className="App" style={{width: '100%'}}>
      <Nav />
      <Landing />
      <Projects />
      <Education />
      <Experience />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
